import {Injectable, Injector} from "@angular/core";

import {HttpService, JsonProperty} from 'projects/core/src/public-api';
import {Observable} from "rxjs";
import {InstallationQuote} from "./Installation-quote";
import {FileService} from '../../../../core/src/lib/misc/data/file/file.service';
import {ProjectFile} from '../../../../app-misc/src/app/modules/project-misc/data/project/project-file';
import {HttpEvent} from '@angular/common/http';
import {JsonObject} from '../../../../core/src/public-api';
import {ResponcePage} from "projects/core/src/lib/misc/data/responce-page";

@JsonObject('QuotesResponsePage')
export class QuotesResponsePage extends ResponcePage {

  @JsonProperty([InstallationQuote], 'content')
  content: InstallationQuote[];
}

@Injectable({
  providedIn: 'root',
})
export class QuotesService extends HttpService {

  constructor(
    protected injector: Injector,
    protected fileService: FileService
  ) {
    super(injector);
  }


  getQuoteByCode(code: string): Observable<InstallationQuote> {
    return this.getData(`/notification/installation-quote/code/${code}`, InstallationQuote);
  }

  getMyQuotes(): Observable<QuotesResponsePage> {
    return this.getData(`/notification/my/list/install-quotes?start=0&limit=10`, QuotesResponsePage);
  }

  sendQuoteByCode(code: string, quote: InstallationQuote): Observable<InstallationQuote> {
    return this.putData(`/notification/installation-quote/code/${code}/provide-price`, {
      price: quote.price
    }, InstallationQuote);
  }

  sendQuote(quote: InstallationQuote): Observable<InstallationQuote> {
    return this.putData(`/notification/installation-quote/${quote.id}/provide-price`, {
      price: quote.price
    }, InstallationQuote)
  }

  getQuoteFiles(quoteId: number): Observable<ProjectFile[]> {
    return this.getData(this.fileService.getListFilesLink('quote', quoteId), ProjectFile);
  }

  getQuoteFilesByCode(quoteCode: string): Observable<ProjectFile[]> {
    return this.getData(this.fileService.getListFilesLinkForQuote(quoteCode), ProjectFile);
  }

  uploadQuoteFiles(files: File[], quoteId: number): Observable<HttpEvent<ProjectFile[]>> {
    return this.fileService.postFile<ProjectFile[]>(this.fileService.getUploadFileLink('quote', quoteId), 'files', files);
  }

  uploadQuoteFilesByCode(files: File[], quoteCode: string): Observable<HttpEvent<ProjectFile[]>> {
    return this.fileService.postFile<ProjectFile[]>(this.fileService.getUploadFileLinkForQuote(quoteCode), 'files', files);
  }


}
